export default "__VITE_ASSET__DpcTNgy3__"